import * as React from "react";
import type { SVGProps } from "react";
const SvgFriends = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M11.793 3.21a2.75 2.75 0 0 1 3.808 2.539 2.76 2.76 0 0 1-.751 1.885 4.34 4.34 0 0 1 2.334 3.84.417.417 0 0 1-.834 0 3.497 3.497 0 0 0-2.266-3.27 2.75 2.75 0 0 1-2.47.001q-.23.09-.445.21a3.026 3.026 0 0 1 .585 4.703 4.8 4.8 0 0 1 2.646 4.28.417.417 0 0 1-.834.002 3.964 3.964 0 0 0-2.593-3.71c-.427.217-.9.333-1.38.334H9.59a3 3 0 0 1-1.357-.327 3.96 3.96 0 0 0-2.618 3.72.416.416 0 1 1-.833-.002 4.8 4.8 0 0 1 2.666-4.289 3.023 3.023 0 0 1 .574-4.709 4 4 0 0 0-.456-.213 2.75 2.75 0 0 1-2.47.001 3.5 3.5 0 0 0-2.264 3.27.416.416 0 1 1-.833-.001 4.33 4.33 0 0 1 2.333-3.84 2.749 2.749 0 1 1 4.18-3.56 2.75 2.75 0 0 1 .204 3.045 2.8 2.8 0 0 1-.387.518q.337.175.639.406a3 3 0 0 1 1.253-.002q.299-.229.632-.403a2.748 2.748 0 0 1 .939-4.427M10.56 9.03a2.191 2.191 0 1 0 .118 3.873.4.4 0 0 1 .078-.047 2.19 2.19 0 0 0 .862-2.705 2.2 2.2 0 0 0-1.058-1.12M6.827 3.898a1.918 1.918 0 0 0-2.393 2.107 1.918 1.918 0 0 0 3.56.7 1.917 1.917 0 0 0-1.167-2.806m6.517 0a1.917 1.917 0 1 0-.99 3.705 1.917 1.917 0 0 0 .99-3.705" />
  </svg>
);
export default SvgFriends;
